// Central place for mobile-specific UI toggles.
// Set `showNavbarOnMobile` to false to hide the AppNavbar when running inside the mobile app (Flutter WebView).
export const MOBILE_UI_CONFIG = {
  showNavbarOnMobile: false,
};
